import { render, staticRenderFns } from "./TesseractDarkIcon.vue?vue&type=template&id=34438f01&"
import script from "./TesseractDarkIcon.vue?vue&type=script&lang=ts&"
export * from "./TesseractDarkIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports